interface IntercomCommandSignature {
    showNewMessage: (prepopulateMessage?: string) => void;
    trackEvent: (tag?: string, metadata?: Record<string, unknown>) => void;
}

type IntercomCommand = keyof IntercomCommandSignature;

// https://developers.intercom.com/installing-intercom/docs/intercom-javascript
interface IntercomStatic {
    <Command extends IntercomCommand>(
        command: Command,
        ...params: Parameters<IntercomCommandSignature[Command]>
    ): ReturnType<IntercomCommandSignature[Command]>;
}

declare global {
    interface Window {
        Intercom: IntercomStatic;
    }
}

export const showNewMessage = (message?: string) => window.Intercom?.('showNewMessage', message);
export const trackEvent = (eventName: string, metadata?: Record<string, unknown>) =>
    window.Intercom?.('trackEvent', eventName, metadata);

export default {
    showNewMessage,
    trackEvent,
};
